import { render, staticRenderFns } from "./TableDeSeriesFiscais.vue?vue&type=template&id=2aff2f23&"
import script from "./TableDeSeriesFiscais.vue?vue&type=script&lang=ts&"
export * from "./TableDeSeriesFiscais.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports